const getters = {
    userInfo: state => state.user.userInfo,
    jobNo: state => state.user.jobNo
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js